import type { SiteSectionCategoryId } from "@/data/common/ids";
import type { SectionNode } from "@/domains/v4b/site-section/site-section.types";

import z from "zod";

import { EProgramApplianceCategory } from "@/domains/v4b/program/program.types";
import { branded } from "@/utils/branded-validation-utils";

const applianceCountByCategorySchema = z.record(z.nativeEnum(EProgramApplianceCategory), z.number());

const sectionParentReferenceSchema = z.object({
  id: branded.sectionId,
  namePath: z.string(),
});

const sectionCategoryReferenceSchema = z.object({
  id: branded.sectionCategoryId,
  name: z.string(),
});

const sectionNodeSchema: z.ZodType<SectionNode> = z.object({
  id: branded.sectionId,
  name: z.string(),
  area: z.number().optional(),
  parent: sectionParentReferenceSchema.optional(),
  category: sectionCategoryReferenceSchema.optional(),
  applianceCountByCategory: applianceCountByCategorySchema,
  children: z.lazy(() => sectionNodeSchema.array()),
});

export const siteSectionFormSchema = z.object({
  name: z.string().min(1, "required"),
  area: z.number().min(0).nullable(),
  parent: sectionNodeSchema.nullable(),
  categoryId: branded.sectionCategoryId.nullable(),
});

export type TSiteSectionFormValues = z.infer<typeof siteSectionFormSchema>;
export type TSectionFormSubmitValues = {
  newValues: TSiteSectionFormValues;
  initialValues: TSiteSectionFormValues;
};

export interface TSectionCategoryFormOption {
  id: SiteSectionCategoryId;
  label: string;
}

export interface ISectionFormExpose {
  focusNameInput: () => Promise<void>;
  submit: () => Promise<TSectionFormSubmitValues | undefined>;
  resetForm: () => void;
  setSiteSectionsFieldsetCustomError: (field: keyof TSiteSectionFormValues, message: string) => void;
}
